import { checkIsAvailableForRentInFuture } from './utils'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import React from 'react'

interface RentButtonProps {
  enlarged?: boolean
  disabled?: boolean
  short?: boolean
  isAvailableForRentNow: boolean
  for_rent?: Record<string, string | null>
  rent: (date?: string | null) => void
  openAvailabilityPopup: () => void
}

const RentButton: React.FC<RentButtonProps> = ({ disabled, short, isAvailableForRentNow, for_rent, enlarged = true, rent, openAvailabilityPopup }) => {
  const { isAvailableForRentInFuture, forRentDates } = checkIsAvailableForRentInFuture(isAvailableForRentNow, for_rent)
  const { t } = useTranslation('mapDetails')

  return (
    <ArrowBtn
      enlarged={enlarged}
      disabled={disabled}
      className={`${(isAvailableForRentNow || isAvailableForRentInFuture) ? '' : '--black'}`}
      text={isAvailableForRentNow ? t(short ? 'rent' : 'rentNow')
        : isAvailableForRentInFuture ? `${t('rentFrom')} ${forRentDates[0]}`
          : t(short ? 'notify' : 'notifyMeAboutAvailability')}
      action={() => {
        if (isAvailableForRentNow) rent()
        else if (isAvailableForRentInFuture) rent(forRentDates[0])
        else openAvailabilityPopup()
      }} />
  )
}

export default RentButton